import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";

import {Persona, TipoContacto, TipoDocumento, Tipos} from "../../../../../auth/register/interfaces/tipos";
import {RegistroService} from "../../../../../auth/register/services/registro-service";
import {ConfirmationService, MessageService} from "primeng/api";
import Swal from "sweetalert2";
import {UsuariosInterface} from "../../../interfaces/usuarios.interface";
import {DropdownChangeEvent, DropdownModule} from "primeng/dropdown";
import {DialogModule} from "primeng/dialog";
import {InputMaskModule} from "primeng/inputmask";
import {Button, ButtonDirective} from "primeng/button";
import {TooltipModule} from "primeng/tooltip";
import {NgClass, NgIf, NgStyle} from "@angular/common";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {RouterLinkActive} from "@angular/router";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {InputTextModule} from "primeng/inputtext";
import {Ripple} from "primeng/ripple";
import {TagModule} from "primeng/tag";
import {ToastModule} from "primeng/toast";
import {ToolbarModule} from "primeng/toolbar";
import {MultiSelectModule} from "primeng/multiselect";
import {FloatLabelModule} from "primeng/floatlabel";
import {CheckboxModule} from "primeng/checkbox";
import {InputNumberModule} from "primeng/inputnumber";
import {AutoFocus} from "primeng/autofocus";
import {DividerModule} from "primeng/divider";
import {InputTextareaModule} from "primeng/inputtextarea";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {AccordionModule} from "primeng/accordion";
import {AutorizacionReq} from "../../../../../officials/autorizaciones/interfaces/autorizaciones-interface";
import {UserSessionReq} from "../../../../../shared/interfaces/user-session-req-interface";
import {LoginServices} from "../../../../../auth/login/services/login.service";
import {TipoAutorizaciones} from "../../../../../shared/interfaces/shared-interface";


@Component({
    selector: 'app-usuario-dialog',
    standalone: true,
    imports: [
        ButtonDirective,
        NgIf,
        ProgressSpinnerModule,
        RouterLinkActive,
        ConfirmPopupModule,
        InputTextModule,
        Ripple,
        TagModule,
        ToastModule,
        ToolbarModule,
        TooltipModule,
        DialogModule,
        MultiSelectModule,
        FormsModule,
        DropdownModule,
        FloatLabelModule,
        NgStyle,
        Button,
        CheckboxModule,
        InputNumberModule,
        NgClass,
        AutoFocus,
        DividerModule,
        InputMaskModule,
        InputTextareaModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        AccordionModule,
    ],
    providers: [MessageService, ConfirmationService],
    templateUrl: './usuario-dialog.component.html',
    styleUrl: './usuario-dialog.component.scss'
})
export class UsuarioDialogComponent implements OnInit{
    @Input() usuarioDialog: boolean=false;
    @Input() estadoAccionUsuario: boolean=false;
    @Input() typeAssign: number=0;
    @Input() headerLabel:string="";
    @Input() typeActionTo!: number; // Tipo de persona a procesar cuando se registra la nueva persona si no se encunetran datos en la busqueda
    @Output() closeAndSaveDialogUser = new EventEmitter<{loading:boolean; case:string;}>();
    @Output() onProcesarDocumentos=new EventEmitter<{documento:string; idTipoDocumento:number;}>();
    uniqueIdInstitucion: string = '588397518122762325'
    loading: boolean=false;
    formRegistro: FormGroup;
    tiposDocumento: Tipos[] = [];
    tiposPersona: Tipos[] = [];
     tiposUsuario: Tipos[] = [];
    tiposContacto: Tipos[] = [];
    tiposDocumentoFiltered: Tipos[] = [];
    usuarioNuevo: UsuariosInterface = {
        uniqueId: "",
        idTipoUsuario: 0,
        idInstitucion: 0,
        usuario: "",
        nombreCompleto: "",
        tipoUsuario: "",
        estado: true,
        verificada: 0,
        codigo: "",
        idTipoCredencial: 0,
        documento: "",
        correo: "",
        roles: [],
    };

    constructor(private registroService: RegistroService, private messageService: MessageService,
                private fb: FormBuilder, private loginServices:LoginServices) {
        this.formRegistro = this.nuevoFormRegistro();
    }
    ngOnInit() {
        this.loadTiposPersona();
        this.loadTipoUsuario();
        this.loadTiposDocumento();
        this.loadTiposContacto();
        this.isValidType();
    }
    nuevoFormRegistro() {
        return this.fb.group({
            tipoPersona: new FormControl<Tipos | null>(null, [Validators.required]),
            tipoUsuario: new FormControl<Tipos | null>({value: null, disabled: true} ),
            tipoDocumento: new FormControl<Tipos | null>(null, [Validators.required]),
            numeroDocumento: new FormControl<number | null>({value: null, disabled: true}, [Validators.required]),
            nombres: new FormControl<string | null>({value: null, disabled: true}, [Validators.required]),
            apellidos: new FormControl<string | null>({value: null, disabled: true}),
            celular: new FormControl<number | null>({value: null, disabled: true}, [Validators.required]),
            fijo: new FormControl<number | null>({value: null, disabled: true}),
            correo: new FormControl({value: null, disabled: true}, [Validators.required, Validators.email]),
        });
    }
    private loadTipoUsuario() {
        return this.registroService.getTiposUsuario()
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tiposUsuario = result.body!;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    private loadTiposPersona() {
        return this.registroService.getTiposPersona()
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tiposPersona = result.body;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    private loadTiposDocumento() {
        return this.registroService.getTiposDocumento()
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tiposDocumento = result.body
                        this.tiposDocumentoFiltered = result.body
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    private loadTiposContacto() {
        return this.registroService.getTiposContacto()
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this.tiposContacto = result.body;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                    this.aplicarConstraints();
                }
            });
    }

    onClearTipoPersona($event: Event): void {
        this.tiposDocumento = this.tiposDocumentoFiltered;
        this.formRegistro.clearValidators()
        this.formRegistro = this.nuevoFormRegistro()
    }

    onChangeTipoPersona($event: DropdownChangeEvent) {
        console.log(JSON.stringify($event));
        if ($event.value === null) {
            return;
        }
        let tipoDocumento: Tipos;
        this.tiposDocumento = this.tiposDocumentoFiltered;
        if ($event.value.idTipoPersona === 1) {//DUI as default
            tipoDocumento = this.tiposDocumento.filter(t => t.nombre.toLowerCase().includes("dui"))[0];
        } else if ($event.value.idTipoPersona === 2) {//NIT as default
            tipoDocumento = this.filtrarNit();
        } else {
        }
        this.formRegistro.patchValue({tipoDocumento: tipoDocumento!})
        this.formRegistro.enable();
        this.restringirNit()
    }
    onChangeTipoDocumento($event: DropdownChangeEvent) {
        if ($event.value === null) {
            return;
        }
        let tipoPersona: Tipos | undefined;
        if ($event.value.idTipoDocumento === 1) {//DUI as default
            tipoPersona = this.tiposPersona.filter(t => t.nombre.toLowerCase().includes("natural"))[0];
        } else if ($event.value.idTipoDocumento === 2) {//NIT as default
            tipoPersona = this.tiposPersona.filter(t => t.nombre.toLowerCase().includes("jurídica"))[0];
            this.filtrarNit();
        } else {
            tipoPersona = this.tiposPersona.filter(t => t.nombre.toLowerCase().includes("natural"))[0];
        }
        this.formRegistro.patchValue({tipoPersona: tipoPersona})
        this.formRegistro.patchValue({numeroDocumento: null})
        this.formRegistro.enable();
        this.formRegistro.markAsUntouched()

    }

    isValidType(){
        if(this.typeAssign==1){//Desactivar el tipo de usuario cuando se realice registro en FU o autorizaciones
            this.formRegistro.get('tipoUsuario')?.setValue([])
            this.formRegistro.get('tipoUsuario')?.disable()
            this.formRegistro.get('tipoUsuario')?.setValidators([])
        }
    }

    isNit() {
        return this.formRegistro.get('tipoDocumento')?.value?.idTipoDocumento == 2
    }

    private filtrarNit() {
        let nit = this.tiposDocumento.filter(t => t.nombre.toLowerCase().includes("nit"))[0];
        this.tiposDocumento = []
        this.tiposDocumento.push(nit)
        return nit;
    }

    private restringirNit() {
        if (this.isNit()) {
            this.formRegistro.get('apellidos')?.setValue('')
            this.formRegistro.get('apellidos')?.disable()
            this.formRegistro.get('apellidos')?.setValidators([])
            this.formRegistro.get('tipoUsuario')?.setValue([])
            this.formRegistro.get('tipoUsuario')?.disable()
            this.formRegistro.get('tipoUsuario')?.setValidators([])
        } else {
            if(this.typeAssign!==1){
                this.formRegistro.get('tipoUsuario')?.enable()
                this.formRegistro.get('tipoUsuario')?.setValidators([Validators.required])
            }
            this.formRegistro.get('apellidos')?.enable()
            this.formRegistro.get('apellidos')?.setValidators([Validators.required])
        }
        this.formRegistro.enable();
        this.formRegistro.updateValueAndValidity()
        this.formRegistro.clearValidators()
    }
    aplicarConstraints() {
        console.log('aplicarConstraints call')
        if (this.tiposContacto != null && this.tiposContacto.length > 0) {
            let email = this.tiposContacto.filter(t => t.tipo?.toLowerCase().includes("email"))[0];
            let celular = this.tiposContacto.filter(t => t.tipo?.toLowerCase().includes("telefono_celular"))[0];
            this.formRegistro.get('correo')?.setValidators([Validators.required, Validators.email, Validators.minLength(<number>email.min), Validators.maxLength(<number>email.max)])
            this.formRegistro.get('celular')?.setValidators([Validators.required, Validators.minLength(<number>celular.min), Validators.maxLength(<number>celular.max)])
            this.formRegistro.updateValueAndValidity()
        }
    }

    closeDialogUser() {
        this.usuarioDialog=false;
        this.closeAndSaveDialogUser.emit({loading:this.loading, case:"close"});
        this.formRegistro.reset();//limpiado datos del formRegistro
    }
    onConfirmSubmit() {
        if(this.estadoAccionUsuario){
            this.onSubmit()
        }else{
            //proceso para editar
            console.log("EDITAR ------------>")
        }
    }

    private alertSave(type:number) {
        if(type==0){
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Éxito se ha registrado el nuevo usuario",
                showConfirmButton: false,
                timer: 2000
            });
        }
        if(type==1){
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Éxito se ha registrado la persona",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    /**
     * typeAssign=1 Se registro una nueva persona desde el FU
     * este metodo envia numero de documento y idTipoDocumento por medio de emitter donde se reutiliza e componente
     * para visualizar informacion desde el FU de manera dinamica*/
    private procesarDocumentos(typeAssign:number,numero: string, idTipoDocumento: number) {
        if(typeAssign==1){
            this.onProcesarDocumentos.emit({documento:numero,idTipoDocumento:idTipoDocumento});
        }
    }

    /**
     * <h3>Procesar usuario o persona</h3>
     * <p>Este metodo procesa los datos para la creacion de usuario o persona desde el FU</p>
     * <lu>
     *     <li>Caso de uso: typeAssign=0 Proceso para registrar un nuevo usuario y se mostraran alerta de nuevo usuario</li>
     *     <li>Caso de uso: typeAssign=1 Proceso para registrar un nuevo persona y se mostraran alerta persona</li>
     * </lu>
     * @since 08/01/2025
     * */
    onSubmit() {
        this.loading = true;
        if (!this.formRegistro.valid) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Ocurrió un error al procesar, intente mas tarde.'
            });
            return;
        }
        let contacts: TipoContacto[] = [];
        let email: TipoContacto = {
            idContactoTipo: 1,
            contacto: this.formRegistro.get('correo')?.value.toString()
        }
        let celular: TipoContacto = {
            idContactoTipo: 2,
            contacto: this.formRegistro.get('celular')?.value.toString()
        }
        contacts.push(celular);
        contacts.push(email)
        let docs: TipoDocumento[] = [];
        let doc: TipoDocumento = {
            idTipoDocumento: this.formRegistro.get('tipoDocumento')?.value.idTipoDocumento,
            numero: this.formRegistro.get('numeroDocumento')?.value.toString()
        }
        docs.push(doc)

        let session: UserSessionReq  = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        let nuevaPersona: Persona = {
            idTipoUsuario: this.formRegistro.get('tipoUsuario')?.value.idTipoUsuario,
            idTipoPersona: this.formRegistro.get('tipoPersona')?.value.idTipoPersona,
            nombres: this.formRegistro.get('nombres')?.value,
            apellidos: this.formRegistro.get('apellidos')?.value,
            uniqueIdInstitucion: this.uniqueIdInstitucion,
            contactos: contacts,
            documentos: docs,
            typeActionTo:this.typeActionTo,
            aut: {uniqueIdAutorizado: "", tipo:this.typeActionTo, session},
            session: session,
            credencial:this.typeActionTo>=2?true:false
        }
        this.registroService.preregistrar(nuevaPersona)
            .subscribe({
                next: (result) => {
                    if (result.status == 200 || result.status == 201) {
                        this.alertSave(this.typeAssign);
                        this.closeAndSaveDialogUser.emit({loading:this.loading, case:"save"});
                        this.registroService.preregistroExito.set(true);
                    }
                },
                error: (error) => {
                    console.log(error)
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: `Error: ${error.error.mensaje}`,
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                    this.loading = false;
                },
                complete: () => {
                    this.loading = false;
                    this.closeDialogUser();
                    this.procesarDocumentos(this.typeAssign,doc.numero,doc.idTipoDocumento);
                }
            });
    }

}
